import { createSlice } from '@reduxjs/toolkit';
import { exportVoucher, fetchVouchers } from './Utils/VoucherUtils';

const VoucherSlice = createSlice({
    name: 'Vouchers',
    initialState: {
        filters: {
            'filter[id]': '',
            'filter[code]': '',
            'sort': '',
            'include[0]': 'membership',
            'filter[valid_status]': 'all',
        },
        data: [],
        detail: {},
        isLoading: false,
        isExport: false,
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
        setDetail: (state, action) => {
            state.detail = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVouchers.pending, (state) => {
                // Handle loading state
                state.isLoading = true;
            })
            .addCase(fetchVouchers.fulfilled, (state, action) => {
                // Handle success state
                state.data = action.payload;
                state.isLoading = false;
            })
            .addCase(fetchVouchers.rejected, (state, action) => {
                // Handle error state
                state.isLoading = false;
                console.log('error', action);
            })
            .addCase(exportVoucher.pending, (state) => {
                // Handle loading state
                state.isExport = true;
            })
            .addCase(exportVoucher.fulfilled, (state) => {
                // Handle success state
                state.isExport = false;
            })
            .addCase(exportVoucher.rejected, (state, action) => {
                // Handle error state
                state.isExport = false;
                console.log('error', action);
            });
    }

});

export const { setFilters, setData, setDetail } = VoucherSlice.actions;

export default VoucherSlice.reducer;